import AbstractDispatcher from '@abstracts/AbstractDispatcher';

export default class Touch extends AbstractDispatcher {
    static _instance;
    static _isTouch = null;

    constructor() {
        super();

        Object.assign(this, {
            _touchpoints: []
        });

        // Singleton
        if (Touch._instance) {
            throw new Error('Error: Use Touch.instance instead of new.');
        }
        Touch._instance = this;

        this._init();
    }

    _init() {
        this._handleTouchInteraction = this._handleTouchInteraction.bind(this);
        this._handleMouseInteraction = this._handleMouseInteraction.bind(this);
        this._registerTouch = this._registerTouch.bind(this);

        window.addEventListener('touchstart', this._registerTouch);
        window.addEventListener('touchend', this._registerTouch);

        document.addEventListener('mousemove', this._handleMouseInteraction);
        document.addEventListener('touchstart', this._handleTouchInteraction);
    }

    _registerTouch(e) {
        let touch = e.touches[0] || e.changedTouches[0];

        this._touchpoints.push(touch);
        setTimeout(() => {
            this._touchpoints.splice(this._touchpoints.indexOf(touch), 1);
        }, 1000);
    }

    _handleTouchInteraction(e) {
        document.removeEventListener('touchstart', this._handleTouchInteraction);

        Touch._isTouch = true;

        // We then dispatch the result
        this.dispatch({
            type: TouchEvents.POINTER_CHANGE,
            isTouch: Touch._isTouch
        });

        this._toggleDomElementClass();

        document.addEventListener('mousemove', this._handleMouseInteraction);
    }

    _toggleDomElementClass() {
        // Setting class on document element
        const html = document.documentElement;
        html.classList.remove(Touch._isTouch ? 'no-touchevents' : 'touchevents');
        html.classList.add(Touch._isTouch ? 'touchevents' : 'no-touchevents');
    }

    _handleMouseInteraction(e) {
        // prevent event if the mouse interaction was triggered by a touch event
        if (this._touchpoints.length > 0) {
            e.cancel = true;
            e.returnValue = false;
            e.cancelBubble = true;
            e.preventDefault();
            e.stopPropagation();
        } else {
            document.removeEventListener('mousemove', this._handleMouseInteraction);

            Touch._isTouch = false;

            // We then dispatch the result
            this.dispatch({
                type: TouchEvents.POINTER_CHANGE,
                isTouch: false
            });

            this._toggleDomElementClass();

            document.addEventListener('touchstart', this._handleTouchInteraction);
        }
    }

    /**
     * get isTouch value
     * @returns { boolean } is Touch or not
     */
    static get isTouch() {
        return this._isTouch;
    }

    /**
     * get singleton instance
     * @returns { Touch }  instance's Touch
     */
    static get instance() {
        return Touch._instance;
    }
}

export class TouchEvents {
    static POINTER_CHANGE = 'Touch:POINTER_CHANGE';
}
